<!-- ── Level 2 sub-tabs ───────────────────────────────────────────────── -->
<div class="pricing-tab__subtabs">
  <div
    class="pricing-tab__subtab"
    role="tab"
    [attr.aria-selected]="activeL2Tab === 'observations'"
    [class.active]="activeL2Tab === 'observations'"
    (click)="onL2TabChange('observations')"
  >
    {{ "knowledge_base.subtab.price_observations" | translate }}
  </div>
  <div
    class="pricing-tab__subtab"
    role="tab"
    [attr.aria-selected]="activeL2Tab === 'imports'"
    [class.active]="activeL2Tab === 'imports'"
    (click)="onL2TabChange('imports')"
  >
    {{ "knowledge_base.subtab.price_imports" | translate }}
  </div>
</div>

<!-- ── Info banner ────────────────────────────────────────────────────── -->
<div class="pricing-tab__info-banner">
  <ui-svg-icon svgIcon="info" size="medium"></ui-svg-icon>
  <span *ngIf="activeL2Tab === 'observations'">
    {{ "knowledge_base.info_banner.price_observations" | translate }}
  </span>
  <span *ngIf="activeL2Tab === 'imports'">
    {{ "knowledge_base.info_banner.price_imports" | translate }}
  </span>
</div>

<!-- ── Sub-tab content ─────────────────────────────────────────────────── -->
<ng-container *ngIf="activeL2Tab === 'observations'">
  <app-list-price-observations></app-list-price-observations>
</ng-container>
<ng-container *ngIf="activeL2Tab === 'imports'">
  <app-list-price-imports (openObservations)="openImportObservations($event)"></app-list-price-imports>
</ng-container>
